export default __webpack_public_path__ + "static/media/gallery-wip-blade plug pin_05.cddebba0.jpg";